import React from "react";
// used for making the prop types of this component
import PropTypes from "prop-types";

// core components
import Button from "components/CustomButtons/Button.jsx";

import defaultImage from "assets/img/image_placeholder.jpg";
import defaultAvatar from "assets/img/placeholder.jpg";
import { withStyles } from "@material-ui/styles";

const imageUploadStyles = {
  fileTitle: {
    '& i.fa': {
      margin: '0 5px',
      top: 0,
      fontSize: '14px',
      color: '#989898',
    }
  },
  fileError: {
    fontWeight: 'bold',
    color: '#dc3545'
  },
  fileInput: {
    margin: 0,
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'end',
    flexDirection: 'column'
  },
  fileInputActions: {
    display: 'flex',
    justifyContent: 'end'
  }
}

class ImageUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: null,
      imagePreviewUrl: this.props.avatar ? defaultAvatar : defaultImage
    };
    this.handleImageChange = this.handleImageChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }
  handleImageChange(e) {
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      this.setState({
        file: file,
        fileType: file.type,
        imagePreviewUrl: reader.result
      });
      // revisar si es mejor pasar el onChange dentro del onloaden
      this.props.onChangeFile(file)
    };
    reader.readAsDataURL(file);

  }
  handleSubmit(e) {
    e.preventDefault();
    // this.state.file is the file/image uploaded
    // in this function you can save the image (this.state.file) on form submit
    // you have to call it yourself
  }
  handleClick() {
    this.refs.fileInput.click();
  }
  handleRemove() {
    this.setState({
      file: null,
      fileType: null,
      imagePreviewUrl: this.props.avatar ? defaultAvatar : defaultImage
    });
    if(this.props.onChangeFile)
      this.props.onChangeFile(null)
    this.refs.fileInput.value = null;
  }
  render() {
    var {
      avatar,
      addButtonProps,
      changeButtonProps,
      removeButtonProps,
      classes,
      fileLabel,
    } = this.props;
    const { file, fileType } = this.state;
    return (
      <div className={`fileinput ${classes.fileInput}`}>
        <input type="file" accept="application/pdf" onChange={this.handleImageChange} ref="fileInput" />
        { file && fileType === 'application/pdf' && (
          <div>
            <h5 className={classes.fileTitle}><b>{fileLabel || 'Archivo'}:</b> {file.name}</h5>
          </div>
        )}

        {file && fileType !== 'application/pdf' && (
          <i className={classes.fileError}>Debes adjuntar un archivo en formato PDF.</i>
        )}

        <div className={classes.fileInputActions}>
          {file === null ? (
            <Button {...addButtonProps} onClick={() => this.handleClick()}>
              {avatar ? "Add Photo" : this.props.title}
            </Button>
          ) : (
            <>
              <Button {...changeButtonProps} onClick={() => this.handleClick()}>
                <i className="fa fa-paperclip"/>
              </Button>
              {avatar ? <br /> : null}
              <Button
                {...removeButtonProps}
                onClick={() => this.handleRemove()}
              >
                <i className="fa fa-times"/>
              </Button>
            </>
          )}
        </div>
      </div>
    );
  }
}

ImageUpload.propTypes = {
  avatar: PropTypes.bool,
  fileLabel: PropTypes.string,
  addButtonProps: PropTypes.object,
  changeButtonProps: PropTypes.object,
  removeButtonProps: PropTypes.object
};

export default withStyles(imageUploadStyles)(ImageUpload);



// WEBPACK FOOTER //
// ./src/components/CustomUpload/ImageUpload.jsx
